import { lazy } from 'react'

export const MyTicketDashboard = lazy(() => import('./my_ticket/MyTicketDashboard'))
export const TicketList = lazy(() => import('./ticket/TicketList'))
export const TicketDetails = lazy(() => import('./ticket/TicketDetails'))
export const FindServiceList = lazy(() => import('./find_service/FindServiceList'))
export const FindServiceDetails = lazy(() => import('./find_service/FindServiceDetails'))
export const IncidentReports = lazy(() => import('./incident_reports/IncidentReports'))
export const TechnicalTickets = lazy(() => import('./technical_tickets/TechnicalTickets'))
export const AdminTicket = lazy(() => import('./admin_ticket/AdminTicket'))
export const TechnicalTicketHistory = lazy(() => import('./admin_ticket/TechnicalTicketHistory'))
export const TechnicalTicketDetails = lazy(() => import('./admin_ticket/TechnicalTicketDetails'))
